
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.995 .995)","stroke":"#000","stroke-width":"1.5","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"x":".688","y":"2.063","width":"20.634","height":"19.259","rx":"1.5"}}),_c('path',{attrs:{"d":"M4.815.688v2.751M17.195.688v2.751M11.693 16.508h4.127M11.693 9.629h4.127M9.08 14.031l-2.89 3.852-2.063-2.063M9.08 6.878L6.19 10.73 4.127 8.666"}})])])
          )
        }
      }
    